import React, { useLayoutEffect, useRef, useState } from "react";

/* Imports */
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import am5themes_Responsive from "@amcharts/amcharts5/themes/Responsive";
import am5locales_fa_IR from "../../../Assets/lang/fa_IR";
// import  "@amcharts/amcharts4/";
// import { Col } from "reactstrap";
import $ from "jquery";
// import data from "./chart1Data.json";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import moment from "jalali-moment";
import useFetch from "../../../Controllers/useFetch";
import { Spin } from "antd";
import { gql, useQuery } from "@apollo/client";

// am4core.useTheme(am5themes_Animated);

function processTo5MinuteIntervals(data) {
  // 1. گروه‌بندی داده‌ها به بازه‌های 5 دقیقه‌ای
  const groupedData = {};
  
  data.forEach(item => {
    const date = new Date(item.date_time);
    // محاسبه دقیقه گرد شده به مضرب 5 (0, 5, 10, ...)
    const roundedMinutes = Math.floor(date.getMinutes() / 5) * 5;
    const roundedDate = new Date(date);
    roundedDate.setMinutes(roundedMinutes, 0, 0);
    const timeKey = roundedDate.getTime();
    
    if (!groupedData[timeKey]) {
      groupedData[timeKey] = {
        date_time: roundedDate,
        values: []
      };
    }
    groupedData[timeKey].values.push(item);
  });

  // 2. محاسبه میانگین و حذف داده‌های پرت برای هر بازه
  const result = [];
  
  Object.keys(groupedData).forEach(timeKey => {
    const group = groupedData[timeKey];
    const fields = ['Ppv', 'Pline', 'Pbat', 'SOC'];
    const processedItem = { date_time: group.date_time };
    
    fields.forEach(field => {
      // استخراج مقادیر این فیلد از تمام داده‌های گروه
      const values = group.values.map(item => item[field]);
      
      // محاسبه میانگین و انحراف معیار
      const mean = values.reduce((sum, val) => sum + val, 0) / values.length;
      const stdDev = Math.sqrt(
        values.reduce((sum, val) => sum + Math.pow(val - mean, 2), 0) / values.length
      );
      
      // فیلتر کردن داده‌های پرت (بیش از 2 انحراف معیار از میانگین)
      const filteredValues = values.filter(
        val => Math.abs(val - mean) <= 1 * stdDev
      );
      
      // محاسبه میانگین نهایی بدون داده‌های پرت
      processedItem[field] = Math.ceil((filteredValues.reduce((sum, val) => sum + val, 0) / filteredValues.length)*1000)/1000;
    });
    
    result.push(processedItem);
  });

  // 3. مرتب کردن بر اساس زمان
  result.sort((a, b) => a.date_time - b.date_time);
  
  return result;
}

function DailyYeildDataProduction({ loading, chartData, time_interval }) {
  const lang_choiced = useSelector((state) => state.lang_change);

  // console.log(loading, "is loading");
  // console.log(chartData, "is daily chartData");
  // const dispatch = useDispatch();
  const chart = useRef(null);
  // console.log(dailyYieldData , 'data yield ')
  useLayoutEffect(() => {
    if (loading === false) {
      // Create root element
      // https://www.amcharts.com/docs/v5/getting-started/#Root_element
      let root = am5.Root.new("chartdiv-dailyYieldDataProduction");
      const responsive = am5themes_Responsive.new(root);

      // Set themes
      // https://www.amcharts.com/docs/v5/concepts/themes/
      root.setThemes([am5themes_Animated.new(root), responsive]);
      root.locale = am5locales_fa_IR;
      // Create chart
      // https://www.amcharts.com/docs/v5/charts/xy-chart/
      let chart = root.container.children.push(
        am5xy.XYChart.new(root, {
          panX: true,
          panY: true,
          wheelX: "panX",
          wheelY: "zoomX",
          maxTooltipDistance: 0,
          pinchZoomX: true,
          layout: root.verticalLayout,

        })
      );

      chart
        .get("colors")
        .set("colors", [
          am5.color(0xb30000),
          am5.color(0x6794dc),
          am5.color(0x68dc76),
          am5.color(0x087f8c),
          am5.color(0x5aaa95),
        ]);

      // Create axes
      // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
      let xAxis = chart.xAxes.push(
        am5xy.DateAxis.new(root, {
          maxDeviation: 0.5,
          baseInterval: {
            timeUnit: "minute",
            count: 5,
          },
          renderer: am5xy.AxisRendererX.new(root, {
            // numberFormatter
          }),
          tooltip: am5.Tooltip.new(root, {}),
          
        })
      );

      // Add series
      // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
      for (var i = 0; i < 4; i++) {
        const yRenderer = am5xy.AxisRendererY.new(root, {
          ariaHidden: true,
          opposite: i === 3 ? true : false
        });
        chart.yAxes.push(
          am5xy.ValueAxis.new(root, {
            autoZoom: false,
            calculateTotals: true,
            // numberFormat: "#,###.###",
            renderer: yRenderer,
            ariaValueText: "[font-family:IRANSans]{valueY}",
            ...(i === 3 && {
              min: 0,    // حداقل مقدار 0%
              max: 100,  // حداکثر مقدار 100%
              strictMinMax: true, // اعمال دقیق محدوده
              extraMax: 0.1, // فضای اضافه در بالا
              extraMin: 0.1  // فضای اضافه در پایین
            })
          })
        );
        let pannelName = `${i === 0
          ? lang_choiced.pages.dashboard.finallyChart.daily.chart.datasets
            .Pout
          : i === 1
            ? lang_choiced.pages.dashboard.finallyChart.daily.chart.datasets
              .Ppannel
            : i === 2 ? lang_choiced.pages.dashboard.finallyChart.daily.chart.datasets
              .Pbat
              : "شارژ باتری"
          }`;
        let series = chart.series.push(
          am5xy.LineSeries.new(root, {
            name: `[font-family:IRANSans]${pannelName}`,
            xAxis: xAxis,
            yAxis: i === 3 ? chart.yAxes.getIndex(3) : chart.yAxes.getIndex(0),
            valueYField: i === 0 ? "Pline" : i === 1 ? "Ppv" : i === 2 ? "Pbat" : "SOC",
            valueXField: "date_time",
            legendValueText: i === 3 ? `[font-family:IRANSans] {valueY}%` : `[font-family:IRANSans] {valueY} kW`,
            tooltip: am5.Tooltip.new(root, {
              pointerOrientation: "right",
              labelText: i === 3 ? `[font-family:IRANSans] {valueY}%` : `[font-family:IRANSans] {valueY} kW`,
            }),
            minDistance: 1,
            connect: true,
          })
        );
        
        if (i === 3) {
          series.strokes.template.set("strokeDasharray", [5]);
        }

        series.data.processor = am5.DataProcessor.new(root, {
          dateFormat: "YYYY-MM-DD HH:mm",
          dateFields: ["date_time"],
        });
        series.data.setAll(processTo5MinuteIntervals(chartData));
        // Make stuff animate on load
        // https://www.amcharts.com/docs/v5/concepts/animations/
        series.appear();
        series.fills.template.setAll({
          fillOpacity:i===3? 0 : 0.5,
          visible: true,
        });
      }

      // Add cursor
      // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
      let cursor = chart.set(
        "cursor",
        am5xy.XYCursor.new(root, {
          behavior: "none",
        })
      );
      cursor.lineY.set("visible", false);

      // Add scrollbar
      // https://www.amcharts.com/docs/v5/charts/xy-chart/scrollbars/
      // chart.set(
      //   "scrollbarX",
      //   am5.Scrollbar.new(root, {
      //     orientation: "horizontal",
      //   })
      // );

      // Add legend
      // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
      // let legend = chart.rightAxesContainer.children.push(
      //   am5.Legend.new(root, {
      //     width: 200,
      //     paddingLeft: 15,
      //     // paddingBottom: 20,
      //     height: am5.percent(100),
      //     position: "relative",
      //   })
      // );
      let legend = chart.children.push(
        am5.Legend.new(root, {
          // centerX: am5.p50,
          // x: am5.percent(50),
          layout: root.gridLayout,
        })
      );

      // legend.valueLabels.template.set("width", 120);
      // When legend item container is hovered, dim all the series except the hovered one
      // legend.itemContainers.template.events.on("pointerover", function (e) {
      //   let itemContainer = e.target;

      //   // As series list is data of a legend, dataContext is series
      //   let series = itemContainer.dataItem.dataContext;

      //   chart.series.each(function (chartSeries) {
      //     if (chartSeries != series) {
      //       chartSeries.strokes.template.setAll({
      //         strokeOpacity: 0.15,
      //         stroke: am5.color(0x000000),
      //       });
      //     } else {
      //       chartSeries.strokes.template.setAll({
      //         strokeWidth: 3,
      //       });
      //     }
      //   });
      // });

      // // When legend item container is unhovered, make all series as they are
      // legend.itemContainers.template.events.on("pointerout", function (e) {
      //   let itemContainer = e.target;
      //   let series = itemContainer.dataItem.dataContext;

      //   chart.series.each(function (chartSeries) {
      //     chartSeries.strokes.template.setAll({
      //       strokeOpacity: 1,
      //       strokeWidth: 1,
      //       stroke: chartSeries.get("fill"),
      //     });
      //   });
      // });

      // legend.itemContainers.template.set("width", am5.p100);
      // legend.valueLabels.template.setAll({
      //   width: am5.p100,
      //   textAlign: "right",
      //   fontFamily: "IRANSans",
      // });

      // legend.labels.template.setAll({
      //   fontSize: 16,
      //   fontWeight: "300",
      //   fontFamily: "IRANSans",
      //   layout: root.verticalLayout,
      // });

      // // It's is important to set legend data after all the events are set on template, otherwise events won't be copied
      legend.data.setAll(chart.series.values);

      // Make stuff animate on load
      // https://www.amcharts.com/docs/v5/concepts/animations/
      chart.appear(1000, 100);
      return () => root.dispose();
    }
  });

  if (loading === true) {
    return (
      <div
        xs="12"
        md="12"
        sm="12"
        lg="12"
        style={{
          width: "100%",
          position: "relative",
          height: "400px",
          overflow: "inherit",
        }}
        className="text-center justify-content-center"
      >
        {" "}
        <Spin
          spinning={true}
          size={"large"}
          style={{ position: "relative", top: "150px" }}
        >
          Loading...
        </Spin>
      </div>
    );
    //   temp1 = 0;
    //   return (
    //     <div
    //       xs="12"
    //       md="12"
    //       sm="12"
    //       lg="12"
    //       id="chartdiv"
    //       style={{
    //         width: "100%",
    //         position: "relative",
    //         height: "400px",
    //         overflow: "inherit",
    //       }}
    //     ></div>
    //   );
  } else {
    //   temp1 = 1;

    return (
      <div
        xs="12"
        md="12"
        sm="12"
        lg="12"
        id="chartdiv-dailyYieldDataProduction"
        style={{
          width: "100%",
          position: "relative",
          height: "450px",
          overflow: "inherit",
          direction: "ltr",
          display: loading ? "none" : "block",
          fontFamily: "IRANSans",
        }}
      ></div>
    );
  }
}

export default React.memo(DailyYeildDataProduction);
